module.exports = __webpack_public_path__ + "media/m6.4c1ad32b.mp4";